import { motion } from "framer-motion";
import { CarsExplorer } from "@/components/cars/CarsExplorer";
import { PlatformColumn } from "@/components/overview/DashboardAnalytics";
import { PageHeader } from "@/components/ui/PageHeader";
import { ColumnSkeleton, ExplorerSkeleton } from "@/components/ui/PageSkeleton";
import { useCars, useHomePlatformData } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function CarsPage() {
  const { data: cars, isLoading, error } = useCars();
  const platform = useHomePlatformData();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="space-y-10"
    >
      <PageHeader
        title="Cars"
        description="Browse and manage vehicles owned by users across the platform — valuations, mileage, and ratings synced live from Supabase."
        showGreeting={false}
      />

      {platform.isLoading ? (
        <ColumnSkeleton compact />
      ) : platform.data?.platform ? (
        <PlatformColumn platform={platform.data.platform} />
      ) : null}

      {isLoading ? (
        <ExplorerSkeleton title="Cars" />
      ) : error ? (
        <p className="text-sm text-red-600">Failed to load cars. Please try again.</p>
      ) : (
        <CarsExplorer cars={cars ?? []} />
      )}
    </motion.div>
  );
}
